import React, { useEffect, useState } from 'react';
import { Container, Button, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/styles.css'; // Assuming your existing styles are here

const NotFound = () => {
  const [micDrop, setMicDrop] = useState(false);

  useEffect(() => {
    // Trigger mic drop animation after a short delay
    const timer = setTimeout(() => setMicDrop(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Container
      fluid
      className="mt-4 mb-4 d-flex align-items-center justify-content-center"
      style={{ minHeight: '100vh', background: 'linear-gradient(to bottom, #ff6b6b, #4ecdc4)' }}
    >
      <div className="text-center card-custom p-5 shadow-lg animate__animated animate__fadeIn">
        {/* Logo */}
        <div className="mb-4 animate__animated animate__bounce" style={{ animationDelay: '0.2s' }}>
          <img
            src="/logo.png"
            alt="It's All Good Karaoke Band Logo"
            style={{
              maxWidth: '200px',
              maxHeight: '150px',
              objectFit: 'contain',
              filter: 'drop-shadow(0 0 10px rgba(255, 215, 0, 0.8))',
            }}
          />
        </div>

        {/* 404 Header with Spin */}
        <h1
          className={`display-1 fw-bold text-dark mb-4 ${micDrop ? 'spin-and-grow' : ''}`}
          style={{ color: '#d63384', fontFamily: "'Poppins', sans-serif" }}
        >
          404
        </h1>

        {/* Funny Message */}
        <h2
          className="fw-bold text-uppercase mb-3 animate__animated animate__slideInUp"
          style={{ color: '#343a40', fontFamily: "'Montserrat', sans-serif', animationDelay: '0.4s'" }}
        >
          Oops, It’s <em>Not</em> All Good!
        </h2>
        <p
          className="lead text-muted mb-4 animate__animated animate__pulse"
          style={{ fontSize: '1.5rem', fontFamily: "'Poppins', sans-serif', animationDelay: '0.6s'" }}
        >
          Looks like this page took the mic and ran off stage! <br />
          Don’t worry, even the best singers hit a wrong note sometimes.
        </p>

        {/* Mic Drop Animation */}
        <div
          className={`mb-4 ${micDrop ? 'dramatic-spotlight' : ''}`}
          style={{
            fontSize: '3rem',
            color: '#ffd700',
            textShadow: '0 0 10px rgba(255, 215, 0, 0.7)',
          }}
        >
          🎤 <span className={micDrop ? 'animate__animated animate__bounce' : ''}>Mic Drop!</span>
        </div>

        {/* Back to Safety Button */}
        <Link to="/">
          <Button
            variant="primary"
            size="lg"
            className="btn-custom-primary animate__animated animate__fadeIn"
            style={{
              background: 'linear-gradient(to right, #ff6b6b, #4ecdc4)',
              border: 'none',
              padding: '15px 30px',
              fontFamily: "'Montserrat', sans-serif'",
              animationDelay: '1s',
            }}
            onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
            onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          >
            Sing Your Way Back Home
          </Button>
        </Link>
      </div>
    </Container>
  );
};

export default NotFound;